/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { css } from '@emotion/core';
import styled from '@emotion/styled';
import media from 'css-in-js-media';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

import { Modal, WistiaVideo, SignupFormModern } from '../slices/atoms';

import {
  styledModal,
} from '../slices/HeroVideo/HeroVideoStyles';

export const query = graphql`
  query HomeQuery($uid: String!) {
    prismic {
      home(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_HomeBodyHerohomeform {
          type
label
primary {
  fullscreen
  background_color
  background_image
  large_text
  email_placeholder
  form_title
  headline
  headline_color
  name_placeholder
  password_placeholder
  subheadline
  subheadline_color
  submit_button_text
  subscript
  text_color
}
fields {
  button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  button_text
  icon
}
        },
        ... on PRISMIC_HomeBodyLogogrid {
          type
            label
            fields {
              logo
            }
            primary {
              text_color
              autoScroll
              background_color
              cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_text
              heading
              heading_color
              subheading
              subheading_color
              scroll_speed
            }
        },
        ... on PRISMIC_HomeBodyTabbedcontent {
          type
            label
            primary {
              background_color
              text_color
              heading
              heading_color
              subheading
              subheading_color
              background_image
            }
            fields {
              content1
              content2
              content3
              content4
              tab_label
              label_color
              content_color
            }
        },
        ... on PRISMIC_HomeBodyCarouselimage {
          type
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading
              subheading_color
            }
            fields {
              image
              image_text
              image_text_color
            }
        },
        ... on PRISMIC_HomeBodyCarouseltestimonial {
          type
            label
            primary {
              background_color
              background_image
              text_color
              heading
              heading_color
              subheading1
              subheading_color
            }
            fields {
              logo
              quote
              author
              author_details
              avatar
              link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              link_text
            }
        },
        ... on PRISMIC_HomeBodyListgridv2 {
          type
            label
            primary {
              background_color
              background_image
              heading
              heading_color
              list_column_number
              list_item_alignment_position
              list_item_heading_color
              list_item_text_color
              list_item_icon_position
              list_item_icon_size
              subheading
              subheading_color
              text_color
              cta_button_text
              cta_button_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              annotation
            }
            fields {
              list_item_heading
              list_item_icon
              list_item_text
              list_item_url_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              list_item_url_text
            }
        },
        ... on PRISMIC_HomeBodyLocations {
          type
            label
            fields {
              location_name
              location_server_name
              location_link_text
              location_link_url {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
            }
            primary {
              background_color
              background_image
              column_number
              heading_color
              heading
              subheading
              subheading_color
              text_color
              location_name_color
              location_server_name_color
              location_link_text_color
            }
        },
        ... on PRISMIC_HomeBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        },
        ... on PRISMIC_HomeBodyPromoband {
          type
label
primary {
  background_color
  cta_button_link {
    ... on PRISMIC__ExternalLink {
      _linkType
      url
    }
  }
  cta_button_text
  heading
  heading_color
  icon
  subheading
  subheading_color
}

        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const homeImageFormTest = {
  "data": {
    "prismic": {
      "homeimageformtest": {
        "body": [
          {
            "type": "herobox",
            "label": null,
            "fields": [{
              "button_link": {
                 "__typename": "PRISMIC__ExternalLink",
                 "_linkType": "Link.web",
                 "url": "https://cloud.digitalocean.com/registrations/google"
              },
              "button_text": "Sign up with Google",
              "icon": {
                 "dimensions": {
                 "width": 18,
                 "height": 18
                 },
                 "alt": null,
                 "copyright": null,
                 "url": "https://prismic-io.s3.amazonaws.com/www-static/8d18ab05-0db4-4fd7-95d1-c5fbc4b83fc2_icon-google.svg"
              }
           }, {
              "button_link": {
                 "__typename": "PRISMIC__ExternalLink",
                 "_linkType": "Link.web",
                 "url": "https://cloud.digitalocean.com/registrations/github"
              },
              "button_text": null,
              "icon": {
                 "dimensions": {
                 "width": 18,
                 "height": 18
                 },
                 "alt": null,
                 "copyright": null,
                 "url": "https://prismic-io.s3.amazonaws.com/www-static/ae808fab-d9d7-458e-b368-05344b7ad308_icon-github.svg"
              }
            }],
            "primary": {
              "fullscreen": false,
              "large_text": true,
              "text_color": "light",
              "hero_background_color": "#0069ff",
              "hero_background_image": {
                "dimensions": {
                  "width": 1600,
                  "height": 800
                },
                "alt": null,
                "copyright": null,
                "url": "https://images.prismic.io/www-static/019f6b3f-5c0b-4ae0-ac3b-ca773cc3d55e_bg-droplets.svg?auto=compress,format"
              },
              "hero_box_cta_text": [{
                "type": "paragraph",
                "text": "Create account",
                "spans": []
              }],
              "hero_box_cta_url": {
                "__typename": "PRISMIC__ExternalLink",
                "_linkType": "Link.web",
                "url": "https://cloud.digitalocean.com/registrations/new"
              },
              "hero_box_title": [{
                "type": "heading5",
                "text": "Starting at $5/mo",
                "spans": []
              }],
              "hero_box_title_color": null,
              "hero_heading": [{
                "type": "heading1",
                "text": "Easy, fast, and flexible compute",
                "spans": []
              }],
              "hero_small_heading": [{
                "type": "paragraph",
                "text": "Droplets",
                "spans": []
              }],
              "hero_small_heading_icon": {
                "dimensions": {
                  "width": 24,
                  "height": 24
                },
                "alt": null,
                "copyright": null,
                "url": "https://images.prismic.io/www-static/547e3d57-13d9-47ff-851c-9f29e8423923_icon-droplets.svg?auto=compress,format"
              },
              "hero_subheading": [{
                "type": "heading2",
                "text": "Spin up your choice of virtual machine in just 55 seconds. Basic, General Purpose, CPU-Optimized, or Memory-Optimized configurations provide flexibility to build, test, and grow your app from startup to scale.",
                "spans": []
              }],
              "hero_box_cta_scroll_to_element_id": null,
              "hero_box_cta_id": "droplet-create-cta",
              "email_placeholder": "Email address",
              "name_placeholder": "Name",
              "password_placeholder": "Create a password",
              "submit_button_text": "Sign up with email",
              "form_title_home": [{
                "type": "heading1",
                "text": "Deploy in seconds",
                "spans": []
              }],
              "subscript": [{
                "type": "paragraph",
                "text": "By signing up you agree to the Terms of Service.",
                "spans": [{
                "start": 31,
                "end": 47,
                "type": "hyperlink",
                "data": {
                    "link_type": "Web",
                    "url": "https://www.digitalocean.com/legal/terms-of-service-agreement/"
                }
                }]
              }],
            }
          }
        ]
      }
    }
  }
}

const businessPageData = {
  "data": {
    "prismic": {
      "businessoverview": {
        "body": [
          {
            "type": "cardshoverlinks",
            "label": null,
            "fields": [
              {
                "card_icon": {
                  "dimensions": {
                    "width": 40,
                    "height": 40
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/9a0e17ef-cd6e-432d-a137-28713dbb6b5d_icon-compute.svg"
                },
                "card_text": "Confidently build and release with scalable compute products in the cloud.",
                "card_title": [
                  {
                    "type": "heading1",
                    "text": "Compute",
                    "spans": []
                  }
                ],
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/droplets/"
                },
                "link_1_text": "Droplets",
                "link_2": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/kubernetes/"
                },
                "link_2_text": "Kubernetes",
                "link_3": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/app-platform/"
                },
                "link_3_text": "App Platform",
                "link_4": null,
                "link_4_text": null,
                "link_only_card": "false"
              },
              {
                "card_icon": {
                  "dimensions": {
                    "width": 40,
                    "height": 40
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/f0f46213-f267-4c25-b813-5f7350908b23_icon-databases.svg"
                },
                "card_text": "Optimize your application’s performance with fully managed databases.",
                "card_title": [
                  {
                    "type": "heading1",
                    "text": "Databases",
                    "spans": []
                  }
                ],
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/managed-databases-mongodb/"
                },
                "link_1_text": "MongoDB",
                "link_2": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/managed-databases-mysql/"
                },
                "link_2_text": "MySQL",
                "link_3": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/managed-databases-postgresql/"
                },
                "link_3_text": "PostgreSQL",
                "link_4": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/managed-databases-redis/"
                },
                "link_4_text": "Redis",
                "link_only_card": "false"
              },
              {
                "card_icon": {
                  "dimensions": {
                    "width": 40,
                    "height": 40
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/f54297ed-68b7-4e7a-ae81-8d2e81d4a102_icon-storage.svg"
                },
                "card_text": "With highly available and scalable storage options, you can store and quickly access any amount of data.",
                "card_title": [
                  {
                    "type": "heading1",
                    "text": "Storage",
                    "spans": []
                  }
                ],
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/block-storage/"
                },
                "link_1_text": "Block Storage",
                "link_2": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/spaces/"
                },
                "link_2_text": "Object Storage",
                "link_3": null,
                "link_3_text": null,
                "link_4": null,
                "link_4_text": null,
                "link_only_card": "false"
              },
              {
                "card_icon": {
                  "dimensions": {
                    "width": 40,
                    "height": 40
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/75057db5-c881-4d05-b24e-052bed4e7a25_icon-networking.svg"
                },
                "card_text": "Secure resources and route applications with highly reliable and customizable networking products.",
                "card_title": [
                  {
                    "type": "heading1",
                    "text": "Networking",
                    "spans": []
                  }
                ],
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/cloud-firewalls/"
                },
                "link_1_text": "Firewalls",
                "link_2": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/load-balancer/"
                },
                "link_2_text": "Load Balancers",
                "link_3": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/docs/networking/dns/"
                },
                "link_3_text": "DNS",
                "link_4": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/docs/networking/private-networking/"
                },
                "link_4_text": "Private Networking",
                "link_only_card": "false"
              },
              {
                "card_icon": {
                  "dimensions": {
                    "width": 40,
                    "height": 40
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/3926c760-a868-4c24-a1c9-8a8b9f097544_icon-marketplace.svg"
                },
                "card_text": "Build faster and smarter with a diverse catalog of preconfigured 1-Click Apps.",
                "card_title": [
                  {
                    "type": "heading1",
                    "text": "Marketplace",
                    "spans": []
                  }
                ],
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/marketplace/"
                },
                "link_1_text": "Marketplace",
                "link_2": null,
                "link_2_text": null,
                "link_3": null,
                "link_3_text": null,
                "link_4": null,
                "link_4_text": null,
                "link_only_card": "false"
              },
              {
                "card_icon": null,
                "card_text": null,
                "card_title": null,
                "link_1": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/"
                },
                "link_1_text": "View our product portfolio",
                "link_2": null,
                "link_2_text": null,
                "link_3": null,
                "link_3_text": null,
                "link_4": null,
                "link_4_text": null,
                "link_only_card": "true"
              }
            ],
            "primary": {
              "background_color": null,
              "background_image": {
                "dimensions": {
                  "width": 24,
                  "height": 24
                },
                "alt": null,
                "copyright": null,
                "url": "https://prismic-io.s3.amazonaws.com/www-static/e2b726ab-087a-4e53-8aca-65826c3f93e7_bg-grid.svg"
              },
              "subtitle": "Develop, manage, and scale your applications on DigitalOcean’s complete cloud platform.",
              "title1": [
                {
                  "type": "heading1",
                  "text": "Tailored for growing businesses",
                  "spans": []
                }
              ]
            }
          },
          {
						"type": "quote",
						"label": null,
						"primary": {
							"quote": [{
								"type": "paragraph",
								"text": "As a founder and somebody that doesn't have a DevOps background, I didn't spend every morning of my life wearing a pager and doing XML sit-ups…what I wanted to do was ship an application to users so that we could begin iterating it.",
								"spans": []
							}],
							"align_content": "center",
							"author_details": "Cofounder & CEO of Parabol",
							"author_image": null,
							"author_name": "Jordan Husney",
							"background_color": "#214896",
							"background_image": null,
							"logo": {
                "dimensions": {
                  "width": 262,
                  "height": 47
                },
                "alt": "Cloudways",
                "copyright": null,
                "url": "https://www-static.cdn.prismic.io/www-static/51b30313-4461-4791-9dae-edad80d4ece6_parabol_logo.svg"
              },
							"text_color": "light"
						}
					}, 
          {
            "type": "listgridv2",
            "label": null,
            "fields": [
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Web & mobile apps",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/1084f77c-6b8f-4617-aef9-7e29bf6bdc26_icon-web-mobile-apps.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Create and run your web and mobile apps’ backends with lightning speed.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/web-mobile-apps/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Web & mobile app development",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Website hosting",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/0e5f957f-b54d-472f-bc13-30c90b8de213_icon-web-hosting.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Easily and reliably host a website for your business while keeping complete control of the underlying infrastructure.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/website-hosting/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Website hosting in the cloud",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Streaming",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/e4b85240-5a1a-45c0-9c5a-883bd5b49936_icon-web-mobile-apps.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "We provide the combination of flexible compute layers with low-bandwidth pricing that make building a streaming service easy for your developers – and cost-efficient for your business.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/streaming/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Streaming compute services",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Gaming",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/560096ba-e85f-4507-8bee-5422ce59eab2_icon-web-hosting.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Build your game on DigitalOcean with flexible compute options and low-bandwidth pricing that will allow you to scale your game as fast as you want.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/gaming/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Gaming development ",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Big data",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/ef3bcfec-1d19-4735-a680-bc36fc689005_icon-big-data.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Run both batch and streaming big data workloads. Gain valuable insights that help inform business initiatives, improve your customer experience, and drive business growth.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/big-data/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Big Data workloads",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Managed services",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/32d546be-d238-441b-a3ee-4e63a8c28b71_icon-managed-services.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Deploy and integrate any type of managed service – including SaaS, PaaS, DBaaS, and API – using our developer-friendly cloud platform. ",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/managed-services/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Managed services in the cloud",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "For agencies and web dev shops",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/f3553620-11f2-4b7c-b834-04709492d891_icon-web-hosting.png?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "By providing a combination of flexible compute layers with low pricing, we empower you to create more powerful websites and applications for your clients at a lower cost than other cloud providers.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/agency/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Agency and Web Dev shop solutions",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "SaaS Solutions",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/af2ef245-7192-4658-b9fc-26a649414cdc_icon-web-mobile-apps.png?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "With flexible compute options combined with a host of other tools – including Managed Databases and Kubernetes – you can build your SaaS exactly how you want while saving on hosting costs.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/saas/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "SaaS development platform",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Startups",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 140,
                    "height": 120
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://prismic-io.s3.amazonaws.com/www-static/560096ba-e85f-4507-8bee-5422ce59eab2_icon-web-hosting.svg"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "We ensure your cloud bills are predictable and affordable, while providing your business with a range of powerful compute options and networking tools that will scale with your business.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/solutions/startups/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Build your startup in the cloud",
                    "spans": []
                  }
                ]
              }
            ],
            "primary": {
              "annotation": null,
              "background_color": "#ffffff",
              "background_image": null,
              "cta_button_text": null,
              "cta_button_url": null,
              "heading": [
                {
                  "type": "heading1",
                  "text": "Simple solutions for complex issues",
                  "spans": []
                }
              ],
              "heading_color": null,
              "list_column_number": "3",
              "list_item_alignment_position": "left",
              "list_item_heading_color": null,
              "list_item_icon_position": "top",
              "list_item_icon_size": "128",
              "list_item_text_color": null,
              "subheading_color": null,
              "subheading": [
                {
                  "type": "paragraph",
                  "text": "Running a business is hard. Your cloud doesn’t have to be.",
                  "spans": []
                }
              ],
              "text_color": "dark"
            }
          },
          {
            "type": "listgridv2",
            "label": null,
            "fields": [
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Control your costs",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/a61f0779-e2d3-4bc0-a5b7-f86a570d97b6_biz-control-your-costs.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "We offer transparent, predictable pricing so you know what you’ll be paying every single time. Cloud Spectator – an independent benchmarking firm – concluded that DigitalOcean delivers the best CPU performance per dollar when compared with AWS and Google.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/resources/cloud-performance-report/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "View the report",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Protect your information",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/ea7aa838-a352-4240-b9f4-c60576843fc6_biz-protect-your-information.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Our data centers are individually audited and certified by various internationally recognized compliance standards, including SOC 1, SOC 2, PCI-DSS, ISO/IEC 27001:2013 Certification and EU-U.S. and Swiss-U.S. Privacy Shield Certification.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/trust/certification-reports/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Learn more",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Automate & orchestrate with a click",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/c29722f7-089e-410e-874b-d5b5e8c28a8e_biz-automate.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Configure, manage, and scale your infrastructure using popular one-click DevOps tools. Leverage our API and open source libraries to easily manage resources.",
                    "spans": []
                  }
                ],
                "list_item_url_link": null,
                "list_item_url_text": null
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Get global availability",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/12213ebe-2a84-4084-9178-c02a4675bbee_biz-global-availability.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Deliver a great user experiences with 99.99% uptime across eight data centers in 12 worldwide regions.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/trust/certification-reports/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Learn more",
                    "spans": []
                  }
                ]
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "Collaborate with team accounts",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/47de596e-da7f-4da3-b4f2-24ce5b2784ac_biz-team-accounts.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "Enable unified collaboration with distinct user roles, one invoice, and no shared credentials.",
                    "spans": []
                  }
                ],
                "list_item_url_link": null,
                "list_item_url_text": null
              },
              {
                "list_item_heading": [
                  {
                    "type": "heading1",
                    "text": "We’re always here for you",
                    "spans": []
                  }
                ],
                "list_item_icon": {
                  "dimensions": {
                    "width": 340,
                    "height": 281
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/7f7b6732-3cb6-4c2d-a15c-4a0a18725b9f_biz-support.jpg?auto=compress,format"
                },
                "list_item_text": [
                  {
                    "type": "paragraph",
                    "text": "When you need help, get free around-the-clock technical support – or go in depth with Premier Support if your business needs a high-touch, personalized support experience.",
                    "spans": []
                  }
                ],
                "list_item_url_link": {
                  "target": null,
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/products/support/"
                },
                "list_item_url_text": [
                  {
                    "type": "paragraph",
                    "text": "Learn more",
                    "spans": []
                  }
                ]
              }
            ],
            "primary": {
              "annotation": null,
              "background_color": "#ffffff",
              "background_image": null,
              "cta_button_text": null,
              "cta_button_url": null,
              "heading": [
                {
                  "type": "heading2",
                  "text": "Host mission-critical solutions",
                  "spans": []
                }
              ],
              "heading_color": null,
              "list_column_number": "2",
              "list_item_alignment_position": "left",
              "list_item_heading_color": null,
              "list_item_icon_position": "left",
              "list_item_icon_size": "128",
              "list_item_text_color": null,
              "subheading_color": null,
              "subheading": [
                {
                  "type": "paragraph",
                  "text": "Everything you need to run fast and scale faster.",
                  "spans": []
                }
              ],
              "text_color": "dark"
            }
          }
        ],
        "date": "2020-07-07",
        "description": "DigitalOcean business solutions",
        "open_graph_image": null,
        "path": "/business",
        "title": [
          {
            "type": "heading1",
            "text": "Business Solutions",
            "spans": []
          }
        ]
      }
    }
  }
};

const homeBottomBannerSliceReferral = {
  "data": {
    "prismic": {
      "businessoverview": {
        "body": [
          {  
            "type": "ctaband",
              "label": null,
              "primary": {
                "text_color": "light",
                "subheading": null,
                "heading": [
                  {
                    "type": "heading1",
                    "text": "Earn free credits by referring friends to DigitalOcean!",
                    "spans": []
                  }
                ],
                "subheading": [{
                  "type": "paragraph",
                  "text": "Use your personal referral link to share DigitalOcean with your network and earn credits every time a new user signs up and spends $25.",
                  "spans": []
                }],
                "cta_band": null,
                "cta_primary_background_color": "white",
                "cta_text_primary": [{
                  "type": "paragraph",
                  "text": "Learn more",
                  "spans": []
                }],
                "cta_text_secondary": null,
                "cta_url_primary": {
                  "__typename": "PRISMIC__ExternalLink",
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/referral-program/"
                },
                "background_image": {
                  "dimensions": {
                    "width": 1600,
                    "height": 800
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/06945244-6980-4148-9bc0-2e74df36b9c6_referral-promo-image.jpg?auto=compress,format"
                },
                "background_color": "#0069ff"
              }
          }
        ]
      }
    }
  }
};

const homeBottomBannerSliceMigrate = {
  "data": {
    "prismic": {
      "businessoverview": {
        "body": [
          {  
            "type": "ctaband",
              "label": null,
              "primary": {
                "text_color": "light",
                "subheading": null,
                "heading": [
                  {
                    "type": "heading1",
                    "text": "Looking to migrate to DigitalOcean?",
                    "spans": []
                  }
                ],
                "subheading": [{
                  "type": "paragraph",
                  "text": "Leverage free infrastructure credits, robust training, and technical support to ensure a worry-free migration",
                  "spans": []
                }],
                "cta_band": null,
                "cta_primary_background_color": "white",
                "cta_text_primary": [{
                  "type": "paragraph",
                  "text": "Get started",
                  "spans": []
                }],
                "cta_text_secondary": null,
                "cta_url_primary": {
                  "__typename": "PRISMIC__ExternalLink",
                  "_linkType": "Link.web",
                  "url": "https://www.digitalocean.com/migrate/"
                },
                "background_image": {
                  "dimensions": {
                    "width": 1600,
                    "height": 800
                  },
                  "alt": null,
                  "copyright": null,
                  "url": "https://images.prismic.io/www-static/4b42ce9a-46ac-4146-a43b-2d0bc6aaa1dc_bg-solutions-managed-services.jpg?auto=compress,format"
                },
                "background_color": "#0069ff"
              }
          }
        ]
      }
    }
  }
};

const Home = ({ data, location }) => {
  const [modalIsShowing, setModalIsShowing] = useState(false);
  const [modalIsShowingMobile, setModalIsShowingMobile] = useState(false);

  const renderVideoModal = wistiaId => (
    <Modal show={modalIsShowing} css={styledModal} onClose={() => setModalIsShowing(false)}>
        <WistiaVideo wistiaId={wistiaId} autoplay />
    </Modal>
  );

  const renderVideoModalMobile = wistiaId => (
    <Modal show={modalIsShowingMobile} css={styledModal} onClose={() => setModalIsShowingMobile(false)}>
        <WistiaVideo wistiaId={wistiaId} autoplay />
    </Modal>
  );

  const videoPlayClick = event => {
    (event.target.dataset.ismobile ? setModalIsShowingMobile(true) : setModalIsShowing(true))
    window.analytics.track('Web Interaction', {
      action: 'play',
      category: 'video',
      name: 'Company Commercial 2 - Exec Highlights',
    });
    window.optimizely.push({
      type: 'event',
      eventName: 'play_video',
    });
  };

  return data.prismic.home ? (
    <MainLayout location={location} layout='home'>
    <Helmet>
      <title>{(data.prismic.home.title[0] && data.prismic.home.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.home.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.home.path : 'https://www.digitalocean.com' + data.prismic.home.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.home.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.home.title[0] ? data.prismic.home.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.home.description ? data.prismic.home.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.home.open_graph_image ? data.prismic.home.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.home.description ? data.prismic.home.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.home.title[0] ? data.prismic.home.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.home.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.home.path : 'https://www.digitalocean.com' + data.prismic.home.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.home.open_graph_image ? data.prismic.home.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <style type="text/css">{`
          #referralSlice {
            display: none;
          }
          
          #homeHeroVideo {
            display: block;
          }
          
          .container.home.container-main {
            min-height: 1000px;
          }

          #heroHomeImageFormTest {
            width: 100%;
            display: block;
          }

          .heroFormTestWrapper {
            display: flex;
            margin-bottom: 40px;
          }

          .heroFormColumn {
            width: 30%;
            margin-right: 5%;
            margin-left: 5%;
            text-align: center;
            min-width: 495px;

          }

          .heroFormContainer {
            position: relative;
            padding: 0 20px;
          }

          .heroFormContainer .contentFormLine {
            display: block;
            width: 80px;
            border-top: 1px solid rgba(12, 24, 47, 0.15);
            margin: 20px 0 40px 0;
          }

          .heroFormColumn h1 {
            font-size: 48px;
            text-align: left;
            display: inline-block;
            margin-bottom: 0;
            font-family: 'WorkSans-Bold', 'Helvetica', 'sans-serif';
          }

          .heroFormColumn p {
            font-size: 24px;
            font-weight: 400;
            color: #0c182f;
          }

          .heroContentContainer {
            text-align: left;
            display: inline-block;
            margin-top: 50px;
            max-width: 495px;
          }

          .heroImageColumn {
            width: 100vw;
            height: 640px;
            border-radius: 0 0 0 240px;
            position: relative;
            overflow: hidden;
          }

          .heroImageColumn img {
            border-bottom-left-radius: 240px;
            width: 100%;
            min-width: 975px;
          }

          #homeHeroVideo img:hover {
            cursor: url(https://www-static.cdn.prismic.io/www-static/d08f88f9-ddfa-49ac-93dc-15da48fa0b3f_home-video-play-btn.svg) 25 25, auto;
          }

          .mobilePlayButtonContainer {
            position: relative;
            text-align: center;
            display: none;
          }
          
          .mobilePlayButton {
            position: absolute;
            display: inline-block;
            margin-top: 25%;
          }

          .mobilePlayButton img.playButton {
            width: 100px;
            height: 100px;
            border-bottom-left-radius: 0;
          }

          @media (max-width: 768px) {
            .heroFormColumn, .heroImageColumn {
              width: 100%;
            }

            .heroImageColumn {
              border-bottom-left-radius: 0;
              height: auto;
            }

            .heroImageColumn img {
              border-bottom-left-radius: 0;
              min-width: auto;
              width: 100%;
            }

            .heroFormTestWrapper {
              display: block;
              text-align: center;
            }

            .heroFormColumn {
              margin-left: 0;
              margin-right: 0;
              margin-bottom: 60px;
              display: inline-block;
            }

            #homeHeroVideo img:hover {

              cursor: default;
            }

            .heroFormColumn {
              min-width: 100%;
            }

            .mobilePlayButtonContainer {
              display: block;
            }
          }
      `}</style>
    </Helmet>
      <div id="heroHomeImageFormTest">
        <div className="heroFormTestWrapper">
          <div className="heroFormColumn">
            <div className="heroFormContainer">
              <div className="heroContentContainer">
                <h1>Simplify your cloud</h1>
                <p>Build alongside half a million developers and businesses like you.</p>
              </div>
              <span className="contentFormLine" />
              <div>
                <SignupFormModern />
              </div>
            </div>
          </div>
          <div className="heroImageColumn" id="homeHeroVideo">
            <div className="mobilePlayButtonContainer">
              <div className="mobilePlayButton">
                <img
                  src="https://www-static.cdn.prismic.io/www-static/f5be6881-c063-4cef-80a7-8a03c12c16ab_platy-button-mobile.svg"
                  alt="play video"
                  className="playButton"
                  onClick={videoPlayClick}
                  onKeyPress={videoPlayClick}
                  data-ismobile="true"

                  id="videoPlayButtonMobile"
                />
              </div>
            </div>
            <picture
              onClick={videoPlayClick}
              onKeyPress={videoPlayClick}
              id="videoPlayButton"
            >
              <source srcSet="https://images.prismic.io/www-static/f1c133d5-52c0-473b-8246-5ee09c6be245_home-hero-compress-tall.jpg?auto=compress,format" type="image/jpeg" /> 
              <img src="https://images.prismic.io/www-static/f1c133d5-52c0-473b-8246-5ee09c6be245_home-hero-compress-tall.jpg?auto=compress,format" alt="Small businesses use DigitalOcean" />
            </picture>
            <div className="videoMobile">
              {renderVideoModalMobile('3xyxx9a44t')}
            </div>
          </div>
        </div>
        <div className="videoDesktop">
          {renderVideoModal('3xyxx9a44t')}
        </div>
      </div>
      <SliceZone allSlices={businessPageData.data.prismic.businessoverview.body} />
      <div id="migrateSlice">
        <SliceZone allSlices={homeBottomBannerSliceMigrate.data.prismic.businessoverview.body} />
      </div>
      <div id="referralSlice">
        <SliceZone allSlices={homeBottomBannerSliceReferral.data.prismic.businessoverview.body} />
      </div>
      
    </MainLayout>
  ) : null;
}

Home.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Home;
